import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(() => [
  {
    boxShadow: 'none',
    borderRadius: 0,
    transition: 'none',
    padding: 0,
  },
  {
    a: {
      width: '33.33%',
    },
  },
]);

export default StyledPaper;
